import axios from "axios";

const createWebRTCConnection = async (WEBRTC_URL, sdp, token) => {
    let allResponse = {}
    try {
        
        allResponse = await axios.post(WEBRTC_URL, sdp ?? "", {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/sdp",
            },
        });
        
        return Promise.resolve(allResponse)
    }
    catch (error) {
        return Promise.reject(error)
    }
}

export default createWebRTCConnection;